import { useEffect, useState } from "react";

import { useNavigate, useOutlet } from "react-router-dom";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";
import styled from "styled-components";
import ArrivalModal from "../components/modal/ArrivalModal";
import OrderCancelModal from "../components/modal/OrderCancelModal";
import { guideState } from "../recoil/guide";
import {
  checkoutDetailType,
  checkoutState,
  checkoutType,
  connectState,
  connectType,
  NewOrderType,
  refreshOrderState,
  requestReviewState,
  RequestReviewType,
} from "../recoil/socket";
import { ORDER_CANCLE_STATUS, ORDER_COM_DEL_STATUS } from "../recoil/type";

import moment from "moment-timezone";
import toast from "react-hot-toast";
import { setRecoil } from "recoil-nexus";
import CheckoutModal from "../components/modal/CheckoutModal";
import RatingModal from "../components/modal/RatingModal";
import SurpriseModal from "../components/modal/SurpriseModal";
import ApiController from "../controller/ApiController";
import {
  CALL_TYPE_RECEIVER,
  CALL_TYPE_SENDER,
} from "../controller/InterphoneController";
import LogController from "../controller/LogController";
import { eventState, EventStateType } from "../recoil/event";
import {
  interphoneAreaState,
  interphoneState,
  InterphoneType,
} from "../recoil/interphone";
import { scheduleState, scheduleType } from "../recoil/schedule";
import { settingsState, SettingType } from "../recoil/settings";
import ChatContent from "./ModalContent/Chat";
import MorningCallContent from "./ModalContent/MorningCall";

let backTimer: any;
const backTime = 60 * 1000 * 30;

export const AllLayout = (oProps: any) => {
  const outlet = useOutlet();
  const navigate = useNavigate();

  const settings = useRecoilValue<SettingType>(settingsState);
  const kioskMode = settings?.view?.kioskmode?.value === "1";
  const isConnect = useRecoilValue<connectType>(connectState);
  const orderRefreshFlag = useRecoilValue<NewOrderType>(refreshOrderState);
  const resetRefreshFlag = useResetRecoilState(refreshOrderState);
  const checkoutFlag = useRecoilValue<checkoutType>(checkoutState);

  const [visibleArrival, setVisibleArrival] = useState<boolean>(false);
  const [visibleCheckout, setVisibleCheckout] = useState<boolean>(false);
  const [visibleRating, setVisibleRating] = useState<boolean>(false);
  const [visibleOrderCancel, setVisibleOrderCancel] = useState<boolean>(false);

  const [pickupName, setPickupName] = useState<string>("");
  const [pickupNameEn, setPickupNameEn] = useState<string>("");
  const [cancelDiscription, setCancelDiscription] = useState<string>("");
  const [orderCategory, setOrderCategory] = useState<number>(0);

  const [checkoutNoticeData, setCheckoutNoticeData] =
    useState<checkoutDetailType>();

  const [ratingInfo, setRatingInfo] = useRecoilState<RequestReviewType | null>(
    requestReviewState
  );
  const event = useRecoilValue<EventStateType>(eventState);
  const schedule = useRecoilValue<scheduleType>(scheduleState);

  const interphoneFlag = useRecoilValue<InterphoneType>(interphoneState);

  // API 호출
  const openCheckoutModal = async () => {
    try {
      // ApiController.checkout.notification(checkoutFlag.notice_detail_id);
      const oRes = await ApiController.checkout.getCheckoutNoticeDetail(
        checkoutFlag.notice_detail_id
      );
      if (oRes && oRes.data.ok) {
        setCheckoutNoticeData(oRes.data.data);
        setRecoil(checkoutState, (prev) => ({
          ...prev,
          extend_types: oRes.data.data.extend_types,
        }));
        setVisibleCheckout(true);
      }
    } catch (e) {
      console.log("err =>", e);
    }
  };

  // 인터폰 id 발급 받은 후 인터폰 페이지로 이동
  const getCallers = async () => {
    try {
      const oParams = {
        manage_id: interphoneFlag.interphone_call_manage_id,
      };
      const oRes = await ApiController.interphone.getCallers(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log("getCallers", oResponse, interphoneFlag);
        if (oResponse.data) {
          if (interphoneFlag.type === CALL_TYPE_RECEIVER) {
            setRecoil(interphoneAreaState, oResponse.data.sender_name);
          } else if (interphoneFlag.type === CALL_TYPE_SENDER) {
            setRecoil(interphoneAreaState, oResponse.data.receiver_name);
          }
          toast.success("통화 시작");
          if (window.location.pathname !== "/interphone") {
            navigate("/interphone");
          }
        }
      }
    } catch (err) {
      console.log("getCallers err---->", err);
    }
  };

  const navigateRest = () => {
    LogController.event({
      path: "MainLayout",
      params: "timer",
      params2: "야간에 화면끄기로 자동 이동",
    });
    console.log("auto turn off");
    navigate("/rest", { replace: true });
    setVisibleRating(false);
  };

  const resetBackTimer = () => {
    if (!window.location.pathname.includes("rest")) {
      clearTimeout(backTimer);

      backTimer = setTimeout(() => {
        if (
          schedule.screen_off_time &&
          moment(new Date()).isSameOrAfter(
            moment(schedule.screen_off_time, "HH:mm:ss")
          ) &&
          new Date().getHours() < 6
        ) {
          navigateRest();
        } else {
          resetBackTimer();
        }
      }, backTime);
    }
  };

  useEffect(() => {
    if (ratingInfo !== null && !kioskMode) {
      setVisibleRating(true);
    }
  }, [ratingInfo]);

  useEffect(() => {
    if (visibleRating) {
      const timer = setTimeout(() => {
        setVisibleRating(false);
        LogController.event({
          path: "RatingModal",
          params: "timer",
          params2: "시간초과로 인해 리뷰 모달 자동으로 닫힘",
        });
      }, 60 * 1000 * 40);

      return () => clearTimeout(timer);
    }
  }, [visibleRating]);

  useEffect(() => {
    resetBackTimer();

    const adverInterval = setInterval(() => {
      setRecoil(guideState, true);
    }, 1000 * 60 * 180);

    return () => {
      clearInterval(adverInterval);
      clearTimeout(backTimer);
      backTimer = null;
    };
  }, []);

  useEffect(() => {
    if (orderRefreshFlag.order_status === ORDER_COM_DEL_STATUS) {
      if (orderRefreshFlag.pickup_name) {
        setPickupName(orderRefreshFlag.pickup_name);
      }
      if (orderRefreshFlag.pickup_name_en) {
        setPickupNameEn(orderRefreshFlag.pickup_name_en);
      }
      setOrderCategory(orderRefreshFlag.order_category);
      if (!kioskMode) {
        setVisibleArrival(true);
      }
    } else if (orderRefreshFlag.order_status === ORDER_CANCLE_STATUS) {
      if (orderRefreshFlag.cancel_description) {
        setCancelDiscription(orderRefreshFlag.cancel_description);
      } else {
        setCancelDiscription("");
      }
      setOrderCategory(orderRefreshFlag.order_category);

      if (!kioskMode) {
        setVisibleOrderCancel(true);
      }
    }
    resetRefreshFlag();
  }, [orderRefreshFlag]);

  useEffect(() => {
    console.log("get Interphone");
    if (
      interphoneFlag.interphone_call_manage_id &&
      window.location.pathname !== "/interphone"
    ) {
      getCallers();
    }
  }, [interphoneFlag.interphone_call_manage_id]);

  useEffect(() => {
    if (
      checkoutFlag &&
      checkoutFlag.notice_detail_id &&
      new Date().getTime() - Number(checkoutFlag.date) < 60 * 1000
    ) {
      openCheckoutModal();
    }
  }, [checkoutFlag.notice_detail_id, checkoutFlag.date]);

  useEffect(() => {
    if (!isConnect.type && !isConnect.is_first) {
      LogController.event({
        path: "AllLayout",
        params: "error",
        params2: "네트워크 연결 확인 알림 발생",
      });
    }
  }, [isConnect]);

  return (
    <Style>
      <div className="screen" onTouchStart={resetBackTimer}>
        {outlet}
      </div>

      {!isConnect.type && !isConnect.is_first && (
        <>
          <div className="toastWrap">
            <div className="customToastWrap">
              <div className="customToast">
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_error.svg`}
                  alt="search"
                />
                <p className="toastMessage">네트워크 연결을 확인해주세요</p>
              </div>
            </div>
          </div>
        </>
      )}
      <ChatContent />
      <MorningCallContent />
      <ArrivalModal
        isVisible={visibleArrival}
        setVisible={setVisibleArrival}
        pickup_name={pickupName}
        pickup_name_en={pickupNameEn}
      />
      <OrderCancelModal
        isVisible={visibleOrderCancel}
        setVisible={setVisibleOrderCancel}
        cancel_description={cancelDiscription}
        order_category={orderCategory}
      />
      <CheckoutModal
        isVisible={visibleCheckout}
        setVisible={setVisibleCheckout}
        checkoutNoticeData={checkoutNoticeData!}
      />
      <RatingModal
        isVisible={visibleRating}
        setVisible={setVisibleRating}
        ratingInfo={ratingInfo}
        setRatingInfo={setRatingInfo}
      />

      <SurpriseModal event={event} />
    </Style>
  );
};

export const Style = styled.div`
  .screen {
    width: 100%;
    height: 100%;
    min-height: auto;
  }

  .toastWrap {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 9999999;
    .customToastWrap {
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .customToast {
      max-width: 90%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 30px;
      text-align: left;
      border-radius: 10px;
      background: #ffffff;
    }
    .toastMessage {
      font-size: 20px;
      margin: 0;
      margin-left: 18px;
      font-weight: 500;
      color: #555555;
    }
  }
`;
